var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"31efc0ec30f3c4c75ffecee1cffd0002715e3efc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["engine-frontend@apollograph"]={id:"31efc0ec30f3c4c75ffecee1cffd0002715e3efc"};
      